<template>
  <flex
    justify="around"
    class="statistics-list">
    <flex
      v-for="(item) in statisticsList"
      :key="item.id"
      direction="column"
      align="center"
      justify="center"
      class="statistics-item">
      <span class="count">{{ item.value }}</span>
      <span class="title">{{ statisticsName(item.id) }}</span>
    </flex>
  </flex>
</template>

<script>
import { getStatisticsList } from '@/api/search'

export default {
  data () {
    return {
      statisticsList: [],
      statisticsNames: [{
        name: '市（州）级',
        prop: 'dishi'
      }, {
        name: '县（市、区、新区）级',
        prop: 'xianqu'
      }, {
        name: '部门',
        prop: 'bumen'
      }, {
        name: '数据库（个）',
        prop: 'shujuku'
      }, {
        name: '数据量（条）',
        prop: 'shujuliang'
      }]
    }
  },
  computed: {
    statisticsName () {
      return filed => {
        let obj = this.statisticsNames.find(v => v.prop === filed)
        return obj ? obj.name : ''
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      getStatisticsList().then(res => {
        this.statisticsList = res.data || []
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.statistics-list
  width 55%
  position absolute
  bottom 350px
  left 50%
  transform translate(-50%)
  // background rgba(0, 0, 0, .1)
  padding 10px
  box-sizing border-box

.statistics-item
  color #fff
  text-shadow 0px 0px 10px rgba(0, 0, 0, .9)

.count
  font-size 36px
  font-family FZYongKeTiS

.title
  margin-top 15px
  font-size 20px
</style>
